// extracted by mini-css-extract-plugin
module.exports = {"TenancyChangeIcon":"Unit_TenancyChangeIcon__3GKxd","TenancyChangeButton":"Unit_TenancyChangeButton__3Ft0D","UnitDetailsList":"Unit_UnitDetailsList__DXStv"};